<div class="modal-header mb-10">
  <div class="modal-title">
    <h3 class="d-inline-block">Test Connectivity Info</h3>
    <button type="button" class="btn-close" (click)="dialogRef().close(false)">
      <span class="icon-close"></span>
    </button>
  </div>
</div>

<div class="modal-body">
  <app-phone-report-connectivity-info [info]="info()"></app-phone-report-connectivity-info>
</div>

<div class="modal-footer pt-15 d-flex justify-content-end">
  <button class="btn btn-primary" type="submit" (click)="onCloseClick()">Close</button>
</div>
